// 員工填班表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import '../../../scss/components/pages/edit_staff_shift.scss';
import Calendar from '../../Calendar';
import moment from 'moment';
import AddShiftBlock from '../../AddShiftBlock';
import EditShiftBlock from '../../EditShiftBlock';
import jobType from '../../../data/jobType.json';

import { 
  getNextShift,
  addWorkTime,
  editWorkTime,
  deleteWorkTime,
  InitAPIStatus
} from '../../../store/action';

class EditStaffShift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        calendarType: "agendaWeek,month",
        defaultView: "month",
        draggable: false,
        isEventClick: true,
        isDayClick: true,
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'agendaWeek,month',
        },
        displayEventEnd: {
          month: true,
          basicWeek: true,
          default: true
        }
      },
      isAddBlockOpen: false,
      isEditBlockOpen: false,
      editDate: moment(),
      currentMonth: moment().month(),
      currentYear: moment().year(),
      editEvent: {},
    }
    this.handleToggleAddShiftOpen = this.handleToggleAddShiftOpen.bind(this);
    this.handleAddshiftByDate = this.handleAddshiftByDate.bind(this);
    this.handleToggleEditShiftOpen = this.handleToggleEditShiftOpen.bind(this);
    this.handleEditshiftByEvent = this.handleEditshiftByEvent.bind(this);
    this.handleSaveAddWorkTime = this.handleSaveAddWorkTime.bind(this);
    this.handleSaveEditWorkTime = this.handleSaveEditWorkTime.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);

  }

  componentDidMount() {
    this.props.getNextShift();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.SendAPIState === 5) {
      swal({
        type: 'error',
        title: '非填班時間',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    }
  }

  handleToggleAddShiftOpen() {
    this.setState({
      isAddBlockOpen: !this.state.isAddBlockOpen
    });
  }

  handleToggleEditShiftOpen() {
    this.setState({
      isEditBlockOpen: !this.state.isEditBlockOpen
    });
  }

  handleAddshiftByDate(moment) {
    this.setState({
      editDate: moment,
      isAddBlockOpen: true
    });
  }

  handleEditshiftByEvent(event) {
    this.setState({
      editEvent: event,
      isEditBlockOpen: true
    });
  }

  handleSaveAddWorkTime(targetevent) {
    let targetStartDay = moment(targetevent.start);
    let targetEndDay = moment(targetevent.end);
    let isOverlide = this.props.staffNextShiftState.events.filter(event => {
      return moment(event.start).format('YYYY-MM-DD') === targetStartDay.format('YYYY-MM-DD');
    }).some(event => {
      return (targetStartDay.diff(moment(event.start)) < 0 && targetEndDay.diff(moment(event.start)) > 0)
       || (targetStartDay.diff(moment(event.end)) < 0 && targetEndDay.diff(moment(event.end)) > 0);
    });
    if (isOverlide) {
      swal({
        type: 'error',
        title: '輸入時段已有排班',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      })
    } else {
      this.props.addWorkTime(targetevent);
    }
  }

  handleSaveEditWorkTime(targetevent) {
    let targetStartDay = moment(targetevent.start);
    let targetEndDay = moment(targetevent.end);
    let isOverlide = this.props.staffNextShiftState.events.filter(event => {
      return moment(event.start).format('YYYY-MM-DD') === targetStartDay.format('YYYY-MM-DD');
    }).filter(event => event.id !== targetevent.id).some(event => {
      return (targetStartDay.diff(moment(event.start)) < 0 && targetEndDay.diff(moment(event.start)) > 0)
       || (targetStartDay.diff(moment(event.end)) < 0 && targetEndDay.diff(moment(event.end)) > 0);
    });
    if (isOverlide) {
      swal({
        type: 'error',
        title: '輸入時段已有排班',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      })
    } else {
      this.props.editWorkTime(targetevent);
    }
  }
  handleMonthChange(currentYear, currentMonth){
    this.setState({
      currentYear: currentYear,
      currentMonth: currentMonth
    });
  }
  render() {
    let { events, eventStartTime, eventEndTime,currentScheduledDays } = this.props.staffNextShiftState;
    let { currentYear, currentMonth} = this.state;

    var total = 0;
    //計算當月事件總時數
    if(events.length>0){
      total =  events.filter(m => m.resourceId === 6).reduce(function(a, b) {

        if(moment(b.start).year() === currentYear && moment(b.start).month() === currentMonth){
          var newMinute = moment(b.end).diff(moment(b.start), 'minute');

          if(newMinute > 240 && newMinute < 480)
            newMinute = newMinute - 30;
          else if(newMinute >= 480 && newMinute < 720)
            newMinute = newMinute - 60;
          else if(newMinute >= 720)
            newMinute = newMinute - 120;

          var totalMinutes = a + newMinute;
          return totalMinutes
        }else{
          return a;
        }
      }, 0);
    }
    return (
      <div className="p-editShift">
        <div className="u-block overflow">

            <div className="u-title">填班表 <span style={{float:'right'}}>填班總時數: {(total/60).toFixed(1)}</span><span style={{float:'right', marginRight: '20px'}}>排班天數: {currentScheduledDays}</span></div>

          <div className="p-editShift__calendar">
            <Calendar {...this.state.calendarConfig} 
              events={events} 
              resources={jobType} 
              startTime={eventStartTime} 
              endTime={eventEndTime}
              handleMonthChange={this.handleMonthChange}
              dayClick={this.handleAddshiftByDate}
              eventClick={this.handleEditshiftByEvent}
            />
          </div>
          <div className="u-notice">填班時間為每月的1~20號。</div>
          <div className="u-notice">忙碌時段: 平常日是中午11-14 晚上17-20；假日是11-16 晚上18-21</div>
        </div>
        {/* <AddShiftBlock isVisible={this.state.isAddBlockOpen} 
          toggleOpen={this.handleToggleAddShiftOpen}
          editDate={this.state.editDate.format('YYYY-MM-DD')}
          saveWorkTime={this.handleSaveAddWorkTime}
        /> */}
        <EditShiftBlock isVisible={this.state.isEditBlockOpen} 
          toggleOpen={this.handleToggleEditShiftOpen}
          event={this.state.editEvent}
          saveWorkTime={this.handleSaveEditWorkTime}
          deleteWorkTime={this.props.deleteWorkTime}
        />
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  staffNextShiftState: store.staffNextShiftState,
})

export default connect(mapStateToProps,{
  getNextShift,
  addWorkTime,
  editWorkTime,
  deleteWorkTime,
  InitAPIStatus
})(EditStaffShift)